(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["commerce-categories"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('[data-commerce-categories]');
  if (!sections.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var coarse = window.matchMedia('(pointer: coarse)').matches;
  sections.forEach(function (section) {
    var cards = section.querySelectorAll('[data-skz-tilt]');
    if (!reduced && !coarse) {
      cards.forEach(function (card) {
        card.addEventListener('pointermove', function (event) {
          var rect = card.getBoundingClientRect();
          var x = (event.clientX - rect.left) / rect.width;
          var y = (event.clientY - rect.top) / rect.height;
          card.style.setProperty('--tilt-x', ((0.5 - y) * 8).toFixed(2) + 'deg');
          card.style.setProperty('--tilt-y', ((x - 0.5) * 10).toFixed(2) + 'deg');
          card.style.setProperty('--pointer-x', (x * 100).toFixed(1) + '%');
          card.style.setProperty('--pointer-y', (y * 100).toFixed(1) + '%');
        });
        card.addEventListener('pointerleave', function () {
          card.style.setProperty('--tilt-x', '0deg');
          card.style.setProperty('--tilt-y', '0deg');
        });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-spotlight-3d"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('[data-product-spotlight]');
  if (!sections.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var coarse = window.matchMedia('(pointer: coarse)').matches;
  sections.forEach(function (section) {
    var visual = section.querySelector('[data-spotlight-tilt]');
    if (visual && !reduced && !coarse) {
      visual.addEventListener('pointermove', function (event) {
        var rect = visual.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width;
        var y = (event.clientY - rect.top) / rect.height;
        visual.style.setProperty('--spot-x', ((0.5 - y) * 7).toFixed(2) + 'deg');
        visual.style.setProperty('--spot-y', ((x - 0.5) * 9).toFixed(2) + 'deg');
      });
      visual.addEventListener('pointerleave', function () {
        visual.style.setProperty('--spot-x', '0deg');
        visual.style.setProperty('--spot-y', '0deg');
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
